import { getTranslate } from 'react-localize-redux';
import { connect } from 'react-redux';
import { Action } from 'redux';
import { ThunkDispatch } from 'redux-thunk';

import { StoreCollectionList as RedesignStoreCollectionList } from '../../../pages';
import {
  FindInitialRestaurant,
  getDataForAllRestaurants,
} from '../../actions/Actions';
import * as Api from '../../Api';
import * as Data from '../../Data';
import { flagService } from '../../services';
import * as Store from '../../Store';
import { default as LegacyCollectionList } from './index.weborder';

const pageComponent = flagService.componentToggle(
  'uiRedesign',
  RedesignStoreCollectionList,
  LegacyCollectionList,
);

export type StateProps = {
  AppConfig: Data.Async<Api.AppConfig>;
  AppDesignScheme: Api.AppDesignScheme;
  collectionRestaurants: Store.CollectionMap;
  collectionSummaries: Data.Async<Api.CollectionRestaurantSummary[]>;
  isDark: boolean;
  LastRestaurantUrl: string;
  Menus: Store.MenuData;
  Restaurants: Data.Async<Api.CollectionRestaurantSummary[]>;
  translate: any;
};
export type DispatchProps = ReturnType<typeof mapDispatchToProps>;

const mapStateToProps = (state: Store.State): StateProps => ({
  AppConfig: state.flipdish.AppConfig,
  AppDesignScheme: state.appDesignScheme,
  collectionRestaurants: state.collectionRestaurants,
  collectionSummaries: state.flipdish.CollectionSummaries,
  isDark: state.flipdish.isDark,
  LastRestaurantUrl: state.flipdish.LastRestaurantUrl,
  Menus: state.flipdish.MenuData,
  Restaurants: state.flipdish.CollectionSummaries,
  translate: getTranslate(state.locale),
});

const mapDispatchToProps = (
  dispatch: ThunkDispatch<Store.State, {}, Action>,
) => ({
  FindInitialRestaurant: (): any => {
    dispatch(FindInitialRestaurant());
  },

  getDataForAllRestaurants: () => {
    dispatch(getDataForAllRestaurants());
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(pageComponent);
